import { css, errorStyle } from "./SKT";
import { SKTBaseComponent } from "./SKTBaseComponent";

export const SKTUnitField = ({
  id,
  label,
  placeholder,
  unit,
  data,
  onChange,
}) => {
  const onchange = (event) => {
    data.set(id, event.target.value);
    if (onChange) onChange(event.target.value);
  };
  return (
    <SKTBaseComponent data={data} id={id} label={label}>
      <div className={css("input-group")}>
        <input
          aria-describedby="basic-addon2"
          style={errorStyle(data.isValid(id))}
          className={css("form-control data")}
          ß
          id={id}
          name={id}
          placeholder={placeholder}
          type="text"
          value={data.get(id)}
          onChange={onchange}
        />{" "}
        <span className={css("input-group-addon")}>{unit}</span>
      </div>
    </SKTBaseComponent>
  );
};
